import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { ChatService } from '../../services/chat.service';
import { ElementRef } from '@angular/core';
import { MessageTimestampComponent } from '../common/message-timestamp/message-timestamp.component';
import { MESSAGE_UNREAD_TEXT } from '../../utils/constants';

@Component({
  selector: 'app-dynamic-pills',
  templateUrl: './dynamic-pills.component.html',
  styleUrls: ['./dynamic-pills.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    FormsModule,
    MatChipsModule,
    MessageTimestampComponent,
  ],
  standalone: true,
})
export class DynamicPillsComponent implements OnInit {
  @Input() input: any;
  @Input() lastMessage: any;
  @Input() isRead: boolean = false;
  @Output() action: EventEmitter<any> = new EventEmitter<any>();

  config: any;
  messageText: string = '';
  inactiveMessage: string = '';
  messageUnreadText: string = MESSAGE_UNREAD_TEXT;

  constructor(private chatService: ChatService, private el: ElementRef) {}

  get configs() {
    return this.chatService.configs;
  }

  ngOnInit() {
    this.config = this.input?.config;
    this.messageText = this.input?.message_text;

    if (this.config && !this.config.active) {
      this.inactiveMessage = 'The options are currently inactive.';
    }
  }

  onPillClick(pill: any) {
    if (!this.config.active) {
      this.inactiveMessage = 'The options are currently inactive.';
    } else {
      this.action.emit({
        type: 'Response',
        button_id: `${pill.id}`,
        message_text: pill.label,
        option: pill,
      });
    }
  }

  ngAfterViewInit() {
    const chips = this.el.nativeElement.querySelectorAll(
      '.mat-mdc-standard-chip'
    );
    chips.forEach((chip: HTMLElement) => {
      chip.classList.remove('mat-mdc-standard-chip');
    });
  }
}
